<template>
  <div id="childrenEducationfinanceTable">
    <!-- 条件查询 -->
    <div class="searchForm">
      <el-form :model="financePrdDTO" inline ref="searchForm">
        <el-row style="margin:0px;">
          <el-col :span="6">
            <el-form-item label="产品代码" prop="prdCode" class="search-ipt">
              <el-input v-model.trim="financePrdDTO.prdCode" size="small" placeholder="请输入产品代码" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称" prop="prdName" class="search-ipt">
              <el-input v-model.trim="financePrdDTO.prdName" size="small" placeholder="请输入产品名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="起购金额(元)" class="search-ipt">
              <el-col :span="11">
                <el-form-item prop="purchaseAmountsFloor" class="search-ipt" style="margin-right:0px">
                  <el-input placeholder="下限值" v-model.number="financePrdDTO.purchaseAmountsFloor"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2" style="text-align:center">
                <span style="color:#999999">—</span>
              </el-col>
              <el-col :span="11">
                <el-form-item prop="purchaseAmountsCeiling" class="search-ipt">
                  <el-input placeholder="上限值" v-model.number="financePrdDTO.purchaseAmountsCeiling"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin:0px;">
          <el-col :span="11">
            <el-form-item label="投资期限(天)" class="search-ipt">
              <el-col :span="11">
                <el-form-item prop="investTermFloor" class="search-ipt" style="margin-right:0px;">
                  <el-input placeholder="下限值" v-model.number="financePrdDTO.investTermFloor" />
                </el-form-item>
              </el-col>
              <el-col :span="2" style="text-align:center">
                <span style="color:#999999">—</span>
              </el-col>
              <el-col :span="11">
                <el-form-item prop="investTermCeiling" class="search-ipt">
                  <el-input placeholder="上限值" v-model.number="financePrdDTO.investTermCeiling" />
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="风险等级" prop="riskLevel" class="search-ipt">
              <el-select v-model="financePrdDTO.riskLevel" size="small" placeholder="请选择">
                <el-option label="全部" value="" />
                <el-option key="1" label="低风险" value="R1" />
                <el-option key="2" label="中低风险" value="R2" />
                <el-option key="3" label="中等风险" value="R3" />
                <el-option key="4" label="中高风险" value="R4" />
                <el-option key="5" label="高风险" value="R5" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品状态" prop="status" class="search-ipt">
              <el-select v-model="financePrdDTO.status" size="small" placeholder="请选择">
                <el-option label="全部" value="" />
                <el-option key="1" label="预售" value="1" />
                <el-option key="2" label="在售" value="2" />
                <el-option key="3" label="售罄" value="3" />
                <el-option key="4" label="停售" value="4" />
                <el-option key="5" label="存续" value="5" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin:0px;">
          <el-col :span="6">
            <el-form-item label="上下架状态" prop="sellStatus" class="search-ipt">
              <el-select v-model="financePrdDTO.sellStatus" size="small" placeholder="请选择上下架状态">
                <el-option label="全部" value="" />
                <el-option key="1" label="上架" value="1" />
                <el-option key="0" label="下架" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否置顶" prop="topFlag" class="search-ipt">
              <el-select v-model="financePrdDTO.topFlag" size="small" placeholder="请选择是否置顶">
                <el-option label="全部" value="" />
                <el-option key="1" label="是" value="1" />
                <el-option key="0" label="否" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin:0px;">
          <el-col :span="24">
            <el-form-item class="search-ipt">
              <el-button size="small" @click="reset">清空</el-button>
              <el-button size="small" type="primary" @click="search">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 产品列表 -->
    <div class="prdList">
      <el-table ref="multipleTable" class="prdTable" :data="tableData" :header-cell-style="{ background: '#F5F7FA' }" tooltip-effect="dark">
        <template slot="empty">
          <p style="position:relative;left:-1250px">{{ emptyText }}</p>
        </template>
        <el-table-column label="选中" fixed="left" width="50" align="center">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.checked" @change="singleAddPrd(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="prdCode" label="产品代码" fixed="left" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="functionList.indexOf('322545212274216960') == '-1'" class="productDecoration" @click="getFinanceDetail(scope.row)" v-html="scope.row.prdCode" />
            <span v-else v-html="scope.row.prdCode" />
          </template>
        </el-table-column>
        <el-table-column prop="prdName" label="产品名称" fixed="left" width="100" align="center" />
        <el-table-column prop="statusRes" label="产品状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.statusRes === '停售' || scope.row.statusRes === '售罄'" style="color:#a2a7b3">{{ scope.row.statusRes }}</span>
            <span v-if="scope.row.statusRes !== '停售' && scope.row.statusRes !== '售罄'">{{ scope.row.statusRes }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sellStatusRes" label="上下架状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.sellStatusRes === '下架'" style="color:#a2a7b3">{{ scope.row.sellStatusRes }}</span>
            <span v-if="scope.row.sellStatusRes !== '下架'">{{ scope.row.sellStatusRes }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="topFlagRes" label="是否置顶" align="center" />
        <el-table-column label="起购金额(元)" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.purchaseAmounts | addMoneyFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="investTerm" label="投资期限(天)" width="130" align="center" />
        <el-table-column prop="expAnnualYield" label="预期年化收益率" width="150" align="center" />
        <el-table-column prop="performanceCriterion" label="业绩比较基准" width="150" align="center" />
        <el-table-column prop="weekAnnualYield" label="七日年化收益率" width="130" align="center" >
          <template slot-scope="scope">
            {{ scope.row.weekAnnualYield}}%
          </template>
        </el-table-column>
        <el-table-column prop="yieldTypeRes" label="收益类型" width="100" align="center" />
        <el-table-column prop="riskLevelRes" label="风险等级" width="130" align="center" />
        <el-table-column prop="operationModeRes" label="运作模式" width="130" align="center" />
        <el-table-column prop="investAssetClassRes" label="投资资产类型" width="130" align="center" />
        <el-table-column prop="initialNetValue" label="初始净值" width="100" align="center" />
        <el-table-column prop="accumultedNetValue" label="累计净值" width="120" align="center" />
        <el-table-column prop="newsetNetValue" label="最新净值" width="120" align="center" />
        <el-table-column prop="newsetNetValueDate" label="最新净值日期" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.newsetNetValueDate*1 | formatToD }}
          </template>
        </el-table-column>
        <el-table-column prop="latestCashYield" label="最近一次兑付收益率" width="150" align="center" >
          <template slot-scope="scope">
            {{ scope.row.latestCashYield}}%
          </template>
        </el-table-column>
        <el-table-column label="购买递增金额(元)" width="150" align="center" >
          <template slot-scope="scope">
                  {{ scope.row.increaseAmounts | addMoneyFilter }}
                </template>
        </el-table-column>
        <el-table-column label="单笔最高限额(元)" width="150" align="center" >
          <template slot-scope="scope">
                  {{ scope.row.singleMaxAmounts | addMoneyFilter }}
                </template>
        </el-table-column>
        <el-table-column label="发售总额(元)" width="150" align="center" >
          <template slot-scope="scope">
                  {{ scope.row.saleAmt | addMoneyFilter }}
                </template>
        </el-table-column>
        <el-table-column label="可售余额(元)" width="150" align="center" >
          <template slot-scope="scope">
                  {{ scope.row.remainAmounts | addMoneyFilter }}
                </template>
        </el-table-column>
        <el-table-column prop="ipoStartDate" label="募集开始日" width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.ipoStartDate*1 | formatToD }}
          </template>
        </el-table-column>
        <el-table-column prop="ipoEndDate" label="募集结束日" width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.ipoEndDate*1 | formatToD }}
          </template>
        </el-table-column>
        <el-table-column prop="establishDate" label="产品成立日" width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.establishDate*1 | formatToD }}
          </template>
        </el-table-column>
        <el-table-column prop="expireDate" label="产品到期日" width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.expireDate*1 | formatToD }}
          </template>
        </el-table-column>
        <el-table-column prop="currencyTypeRes" label="币种" width="130" align="center" />
        <el-table-column prop="isAdvRedeemRes" label="是否可提前赎回" width="140" align="center" />
        <el-table-column prop="issueOrgCode" label="发行机构" width="100" align="center" />
      </el-table>
      <el-row>
        <el-col :span="4">
          <div class="warnText" v-if="tenPrdsFlag">已选产品不能超过10个</div>
          &emsp;
        </el-col>
        <el-col :span="20">
          <yh-pagination :page.sync="currentPage" :limit="pageSize" :total="sumCount" style="padding-top:0px" />
        </el-col>
      </el-row>
    </div>
    <!--产品详情-->
    <financeDetailDialog ref="financeDetailDialog" />
  </div>
</template>

<script>
import { stat } from 'fs';
import financeDetailDialog from '../../../../components/wpsp/productPlan/financeDetailDialog';
import { getFunctionList } from '@/mixins';

export default {
  name: 'financeTable',
  mixins: [getFunctionList],
  components: {
    financeDetailDialog,
  },
  props: {
    selectedTags: Array,
  },
  data() {
    return {
      emptyText: this.$LS.empty,
      currentPage: 1,
      pageSize: 5,
      pageNo: 1,
      sumCount: 0,
      functionList: [],
      financePrdDTO: {
        token: JSON.parse(sessionStorage.getItem('userToken')),
        prdName: '',
        prdCode: '',
        purchaseAmountsFloor: '',
        purchaseAmountsCeiling: '',
        investTermFloor: '',
        investTermCeiling: '',
        riskLevel: '',
        status: '',
        sellStatus: '',
        topFlag: '',
        userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        orgnCode: JSON.parse(sessionStorage.getItem('sessionData')).orgnCode,
        orgnInheritSign: JSON.parse(sessionStorage.getItem('sessionData')).orgnInheritSign,
      },
      depositPrdDTO: {
        token: JSON.parse(sessionStorage.getItem('userToken')),
        prdName: '',
        prdCode: '',
        purchaseAmountsFloor: '',
        purchaseAmountsCeiling: '',
        investTermFloor: '',
        investTermCeiling: '',
        riskLevel: '',
        status: '',
        sellStatus: '',
        topFlag: '',
        userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        orgnCode: JSON.parse(sessionStorage.getItem('sessionData')).orgnCode,
        orgnInheritSign: JSON.parse(sessionStorage.getItem('sessionData')).orgnInheritSign,
      },
      tableData: [],
      multipleSelection: [],
      prdDetailVisible: false,
      tenPrdsFlag: false,
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
    // 监听已选列表长度，不超过10个就将错误提示隐藏
    selectedTags(val) {
      if (val.length <= 10) {
        this.tenPrdsFlag = false;
      }
    },
  },
  methods: {
    // 查询按钮
    search() {
      this.currentPage = 1;
      this.pageNo = 1;
      this.getTableData();
    },
    reset() {
      Object.keys(this.financePrdDTO).forEach((key) => {
        this.financePrdDTO[key] = '';
        this.depositPrdDTO[key] = '';
      });
      this.financePrdDTO.token = JSON.parse(sessionStorage.getItem('userToken'));
      this.financePrdDTO.userId = JSON.parse(sessionStorage.getItem('sessionData')).userId;
      this.financePrdDTO.orgnCode = JSON.parse(sessionStorage.getItem('sessionData')).orgnCode;
      this.financePrdDTO.orgnInheritSign = JSON.parse(sessionStorage.getItem('sessionData')).orgnInheritSign;
      this.depositPrdDTO.token = JSON.parse(sessionStorage.getItem('userToken'));
      this.depositPrdDTO.userId = JSON.parse(sessionStorage.getItem('sessionData')).userId;
      this.depositPrdDTO.orgnCode = JSON.parse(sessionStorage.getItem('sessionData')).orgnCode;
      this.depositPrdDTO.orgnInheritSign = JSON.parse(sessionStorage.getItem('sessionData')).orgnInheritSign;
    },
    // 理财产品列表查询
    getTableData(flag) {
      if (flag === 1) {
        this.reset();
        this.search();
        return;
      }
      this.emptyText = this.$LS.loading;
      const parames = {
        data: {
          financePrdDTO: this.financePrdDTO,
          depositPrdDTO: this.depositPrdDTO,
          productType: '1',
        },
        pageMessage: {
          pageSize: this.pageSize || 5,
          pageNo: this.currentPage,
        },
      };
      this.$_post(this.$API.getFinanceList, parames)
        .then((res) => {
          this.emptyText = this.$LS.emptySearch;
          this.tenPrdsFlag = false;
          const { list } = res.data;
          // 如果没有选择任何产品则取消所有勾
          if (this.selectedTags.length === 0) {
            for (let index = 0; index < list.length; index++) {
              list[index].checked = false;
            }
          }
          for (let j = 0; j < list.length; j++) {
            const product = list[j];
            for (let i = 0; i < this.selectedTags.length; i++) {
              const element = this.selectedTags[i];
              // updateUser、prdType、prdCode确定一条数据
              if (product.prdType === element.prdType && product.prdCode === element.prdCode) {
                product.checked = true;
                break;
              } else {
                product.checked = false;
              }
            }
          }
          this.tableData = list;
          console.log(this.tableData);
          this.sumCount = res.sumCount;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 理财产品详情查询
    getFinanceDetail(row) {
      this.$refs.financeDetailDialog.getFinanceDetail(row.id);
    },
    // 新增===》单选产品
    singleAddPrd(row) {
      const tagVal = {
        prdId: row.id,
        prdName: row.prdName,
        prdCode: row.prdCode,
        prdType: '1',
        addFlag: '1',
        addTime: this.formatTime(new Date()),
      };
      // 如果checked为false并且标记为true，则说明该产品因为超过10个产品而checked值被手动改为false。这里手动改为true并将标记置空，解决了超过10个产品后，取消选择一个产品，再选择该产品无法选择的问题。
      if (row.checked === false && row.passed === true) {
        row.checked = true;
        row.passed = undefined;
      }
      if (row.checked) {
        // 如果已有10个产品则不允许选中，且给一个标记passed（如果手动将checked置为false，那么该产品下次选中时传的值还是false，会造成无法选中的bug）
        if (this.selectedTags.length === 10) {
          row.checked = false;
          row.passed = true;
          this.tenPrdsFlag = true;
          return false;
        }
        this.selectedTags.push(tagVal);
        return true;
      }
      for (let index = 0; index < this.selectedTags.length; index++) {
        const element = this.selectedTags[index];
        if (element.id === tagVal.id || (element.prdName === tagVal.prdName && element.prdType === tagVal.prdType)) {
          this.selectedTags.splice(index, 1);
          break;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#childrenEducationfinanceTable {
  .search-ipt {
    margin: 0px;
  }
  .prdTable {
    width: 100%;
    border: 1px solid #f5f7fa;
  }
  .productDecoration {
    border-bottom: 1px solid #1e88ff;
    color: #1e88ff;
    cursor: pointer;
  }
  .warnText {
    color: red;
    font-size: 12px;
  }
}
</style>
